import _ from 'lodash';
import getHelpers from '../helpers';
const api = getHelpers('api');

// initial state
const state = {
    ...window.store,
    notifications: [],
    timestamp: Date.now(),
}

// getters
const getters = {
    notifications: (state) => state.notifications,
    timestamp: (state) => state.timestamp,
    pathNodes: (state) => state.pathNodes,
    customer: (state) => state.customer,
    route: (state) => (name, params) => {
        let path = '/' + _.get(state, ['routes', name]);

        _.forEach(params, (value, key) => {
            path = _.replace(path, new RegExp(`{${key}[?]?}`), value);
        })

        return path;
    }
}

const actions = {
    addNotification({ commit }, payload) {
        commit('addNotification', payload);
    },
}

// mutations
const mutations = {
    addNotification(state, payload) {
        _.set(state, 'notifications', _.concat(state.notifications, [payload]));
    },
}

export default {
    state,
    getters,
    actions,
    mutations,
}
